export default __webpack_public_path__ + "static/media/Barcode-bro.a6da5786.svg";